if (!customElements.get('collection-user-columns')) {
  class CollectionUserColumns extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'grid-column-type';

      this.bindOnButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      this.productGrid = document.querySelector('#product-grid');
      this.buttons = this.querySelectorAll('.collection-user-columns__btn');
      this.activeButton = this.querySelector('.collection-user-columns__btn.active');

      if (!this.productGrid || this.buttons.length <= 0) return;

      if (!sessionStorage.getItem(this.storageKey))
        this.setColumnType('default');
      else
        this.setColumnType(sessionStorage.getItem(this.storageKey));

      this.currentClass = this.activeButton.dataset.class.split(' ');
      const storageButton = this.querySelector(`.collection-user-columns__btn[data-type="${this.columnType}"]`);

      if (storageButton) this.updateGrid(storageButton)

      this.buttons.forEach(button => {
        button.addEventListener('click', this.bindOnButtonClick)
      })
    }

    onButtonClick(event) {
      this.updateGrid(event.currentTarget);
    }

    updateGrid(trigger) {
      const newClass = trigger.dataset.class.split(' ');
      this.productGrid.classList.remove(...this.currentClass);
      this.productGrid.classList.add(...newClass);

      this.currentClass = newClass;
      this.setColumnType(trigger.dataset.type);
      this.buttons.forEach(button => {
        if (button == trigger) {
          button.classList.add('active');
          button.setAttribute('aria-pressed', true);
        } else {
          button.classList.remove('active');
          button.setAttribute('aria-pressed', false);
        }
      })
    }

    setColumnType(type) {
      this.columnType = type;
      sessionStorage.setItem(this.storageKey, type);
    }
  }

  customElements.define('collection-user-columns', CollectionUserColumns);
}
